import { Button, Stack } from '@mui/material';
import ROUTES from 'constants/routes';
import AuthSplitShell from 'pages/onboarding/components/AuthSplitShell';
import AuthTabs from 'pages/onboarding/components/AuthTabs';
import LoginForm from 'pages/onboarding/Login/components/LoginForm';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import SocialControls from './components/SocialControls';

const Login = () => {
  const { t } = useTranslation();
  const [loginLoading, setLoginLoading] = useState(false);

  const [searchParams] = useSearchParams();
  const searchObject = Object.fromEntries(searchParams);
  const { redirectUrl } = searchObject;

  return (
    <AuthSplitShell>
      <Stack spacing={{ xs: 4, lg: 4.5 }}>
        <AuthTabs activeTab='login' redirectUrl={redirectUrl} />

        <Stack spacing={3}>
          <LoginForm setLoginLoading={setLoginLoading} />

          <Button
            variant='text'
            component={RouterLink}
            to={ROUTES.PASSWORD_RESET}
            disabled={loginLoading}
            sx={{
              width: 'fit-content',
              minWidth: 0,
              px: 0,
              fontSize: 16,
              fontWeight: 600,
            }}>
            {t('passwordReset.link')}
          </Button>

          <SocialControls loginLoading={loginLoading} setLoginLoading={setLoginLoading} />
        </Stack>
      </Stack>
    </AuthSplitShell>
  );
};

export default Login;
